import React from "react";

import "../../../styles/login.css";
import PropTypes from "prop-types";
import Image from "react-bulma-components/lib/components/image";
import Modal from "react-bulma-components/lib/components/modal";
import {inject, observer,} from "mobx-react";
import {withRouter} from 'react-router-dom';
import Button from "react-bulma-components/lib/components/button";
import SocialButton from "./socialLogin";
import Section from "react-bulma-components/lib/components/section";
import {boolean} from "@storybook/addon-knobs";
import {LoginModal} from "./login";
import {fb_code, google_id} from '../../../env/index';
import "../../../styles/signup.css";
import {Label} from "react-bulma-components/lib/components/form";
import {validateIfInputHasSpaces, validateIfInputIsEmail} from "../../../helpers/validationChecks";
import ReactGA from "react-ga";

const imagesPathSignUp = {
    hidePasswordSignUpImg: require('../../../assets/hide-password.png'),
    showPasswordSignUpImg: require('../../../assets/show-password.png')
}

@inject('authStore', 'userStore', 'navigatorStore')
@withRouter
@observer
export default class signup extends React.Component {



    static propTypes = {
        Modal: PropTypes.object,
        showSignInModal: boolean
    };
    static defaultProps = {
        Modal: {},
    };
    constructor() {
        super();
        this.state = {
            show: true,
            credentials: {
                email: "",
                password: "",
                confirmPassword: ""
            },
            submitValid: false,
            submitInProcess: true,
            signupSuccess: false,
            signupFailMsg: "",
            haveAcct: false,
            hiddenPassword: true
        }
    }

    toggleShowPassword = () => {
        this.setState({hiddenPassword: !this.state.hiddenPassword});
    }

    handleSocialLogin(user) {
        // console.log("success =", user);
        var formData = new FormData();
        formData.append('fb_id', user._profile.id);
        localStorage.setItem("fb_email", user._profile.email)
        this.props.authStore.socialLogin(formData)
            .then(() => this.props.userStore.pulluser())
            .then((response) => {
                // this.props.history.replace('/')
                // console.log("this.props.userStore.loginDone", this.props.userStore.loginDone),
                    // console.log("[response in login]", response),
                    this.props.navigatorStore.closeSignInModal(),
                    this.props.navigatorStore.closeSignUpModal(),
                    this.props.authStore.makeRegisterSuccess()
            }
            )


    }

    handleSocialLoginFailure = (err) => {
        console.error(err)
    }
    updateSignInModalState() {
        this.props.navigatorStore.openSignInModal();
    }
    open = () => { this.setState({ show: true }) };
    close = () => { this.props.navigatorStore.closeSignUpModal() };
    onValuChanged(event) {
        // console.log("this is event.targetfghjkl", event.target, event.target.name, event.target.value);
        this.setState({ credentials: { ...this.state.credentials, [event.target.name]: event.target.value } }, () => {
            // console.log("changed the input box ", this.state.credentials);
        })
    }

    onSubmit(e) {
        e.preventDefault()
        // if(!this.state.agreedWithSellerTerms){
        //     this.props.navigatorStore.openErrorModal("Please ensure that you read all the instructions carefully before registering as a seller with YourMasterpieces");
        //     return; 
        // }

        if ((!this.state.credentials.email)) { this.props.navigatorStore.openErrorModal("Please enter a valid email"); return; }
        if (!!this.state.credentials.email && !validateIfInputIsEmail(this.state.credentials.email)) { this.props.navigatorStore.openErrorModal("Please enter a valid email"); return; }
        if (!this.state.credentials.password ) { this.props.navigatorStore.openErrorModal("Please enter a password"); return; }
        if (!!this.state.credentials.password && this.state.credentials.password.length < 6) { this.props.navigatorStore.openErrorModal("Password must have a minimum of 6 characters"); return; }
        if (!this.state.credentials.password) { this.props.navigatorStore.openErrorModal("Please enter your password"); return; }
        if (!validateIfInputHasSpaces(this.state.credentials.password)) { this.props.navigatorStore.openErrorModal("Password must not contain any space"); return; }
        // else if (this.state.credentials.password.length < 8) {   this.props.navigatorStore.openErrorModal("password needs to be of 8 characters"); return; }
        // if (this.state.credentials.password != this.state.credentials.confirmPassword) { this.props.navigatorStore.openErrorModal("Passwords do not match"); return; }
        // console.log("andjsnd", Agent.API_ROOT)
        var self = this;
        // console.log("form data", this.state.credentials, this.state.rememberMe);
     
            // console.log("submit request valid");

            this.props.authStore.register({ email: this.state.credentials.email, password: this.state.credentials.password })
                // .then(() => this.props.userStore.pulluser())
                .then((response) => {
                    // , console.log("this.props.userStore.loginDone", this.props.userStore.loginDone),
                        //console.log("[response in signup]", response),
                            ReactGA.pageview('/Signup action');
                        this.props.navigatorStore.closeSignUpModal()
                    this.props.navigatorStore.closeSignInModal()
                    this.props.authStore.makeRegisterSuccess()
                    // this.props.history.replace('/')
                    // this.setState({
                    //     submitValid: true,
                    //     submitInProcess: false,
                    //     signupSuccess: true
                    // }, ()=>{
                    //     // console.log("this is to redirect to onboarding",this.state.signupSuccess)
                    //     this.props.navigatorStore.closeSignUpModal()
                    //     // this.props.navigatorStore.closeSignInModal(),
                    // })
                }
                )



        


    }
    handleChangeSellerTerms() {
        this.setState({
            agreedWithSellerTerms: !this.state.agreedWithSellerTerms
        })
    }
    render() {



        if (this.state.submitInProcess) {
            // console.log("signup")
            return (
                <div>
                    <div style={{
                        margin: "0 auto", width: "90%"
                    }}>

                        {/* <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.2/css/bulma.min.css"></link> */}
                        {/* <a onClick={this.open} className="open-modal-link-button">LOGIN&SIGNUP</a> */}
                        <Modal show={this.props.navigatorStore.showSignUpModal} onClose={this.close} {...this.props.modal} >
                            {this.props.children}
                            <Modal.Content className="signup-modal-content">
                                <Section style={{backgroundColor: 'white', padding: "none"}}
                                         className="mymodal signModal">
                                    <div className="myimage">
                                        <a href="https://apps.apple.com/in/app/masterpiece-platform-for-non/id1089890769" target="_blank">
                                            <div className="ios-store">
                                                <img src={require('../../../assets/ios_app.png')} className="icon-image"/>
                                            </div>
                                        </a>
                                        <a href="https://play.google.com/store/apps/details?id=com.codon.masterpiece&hl=en" target="_blank">
                                            <div className="playstore-icon">
                                                <img src={require('../../../assets/android_app.png')} className="icon-image"/>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="myform" >
                                        <div style={{textAlign: "left"}} className="log-in">
                                            SIGN UP
                                            <img onClick={this.close} className="cross-icon-for-masterpieces-modal"
                                                 src={require('../../../assets/cross_icon_for_close.png')}></img>
                                        </div>
                                        <div className="ruling-forgot-password-section"></div>
                                        <Label className="label-text mb-15">
                                            <p className="label">EMAIL</p>
                                            <input className="input-rectangle" type="text" name="email" placeholder="Your email" onChange={this.onValuChanged.bind(this)} />
                                        </Label>
                                        <Label className="label-text mb-15">
                                            <p className="label">PASSWORD</p>
                                            <div className="input-group show-hide-input-block">
                                                <input className="input-rectangle"
                                                       type={(this.state.hiddenPassword) ? "password" : "text"}
                                                       name="password"
                                                       placeholder="Create a password"
                                                       onChange={this.onValuChanged.bind(this)}/>
                                                <div className="input-group-append login-input-group">
                                                    <span className="input-group-text">
                                                       <img
                                                           src={(this.state.hiddenPassword) ? imagesPathSignUp.hidePasswordSignUpImg : imagesPathSignUp.showPasswordSignUpImg}
                                                           className="show-password-image"
                                                           onClick={this.toggleShowPassword}/>
                                                    </span>
                                                </div>
                                            </div>

                                        </Label>
                                        {/*<Label className="label-text">
                                            <p className="label">CONFIRM PASSWORD</p>
                                            <input className="input-rectangle" type="password" name="confirmPassword" placeholder="*******" onChange={this.onValuChanged.bind(this)} />
                                         </Label>*/}


                                        <div className="p-0 mb-15">
                                            <div className="pull-left agree-block">
                                                {/* <input name="rememberme" type="checkbox" id="rememberme"
                                                    value={this.state.agreedWithSellerTerms} 
                                                    onClick={this.handleChangeSellerTerms.bind(this)}
                                                    /> */}
                                                <p className="agree-text">
                                                    By clicking on Sign Up, you agree with our
                                                    <a href="/terms-and-conditions" className="agree-link">terms of use.</a>
                                                </p>
                                            </div>

                                            <div className="pull-right signup-btn">
                                                <Button className="button-link-signup"
                                                    onClick={this.onSubmit.bind(this)}>
                                                    SIGN UP
                                            </Button>
                                            </div>
                                        </div>


                                        <div className="already-account">
                                            <div style={{ flex: "1" }} >
                                                <Button className="forgot-password" onClick={this.updateSignInModalState.bind(this)}>
                                                    <p className="button-name login-text">Already have an account ? Log in</p></Button></div>

                                        </div>
                                        <div className="footer-social">
                                            <div style={{
                                                display: "flex",
                                                flex: 1,
                                                padding: "2%",
                                                backgroundColor: "#333333"
                                            }}>
                                            <div className="social">
                                                <p className="social-platform-login">Join with a social platform</p>
                                            </div>
                                            </div>

                                            <div className="social-1" style={{ flex: 1, }}>
                                                <SocialButton
                                                    provider='google'
                                                    appId={google_id}
                                                    onLoginSuccess={this.handleSocialLogin.bind(this)}
                                                    onLoginFailure={this.handleSocialLoginFailure.bind(this)}
                                                >
                                                    <a href="#" >
                                                        <Image src={require('../../../assets/Google.png')} />
                                                    </a>
                                                </SocialButton>
                                            </div >
                                            <div className="social-1" style={{ flex: 1, }}>
                                                <SocialButton
                                                    provider='facebook'
                                                    appId={fb_code}
                                                    onLoginSuccess={this.handleSocialLogin.bind(this)}
                                                    onLoginFailure={this.handleSocialLoginFailure.bind(this)}
                                                >
                                                    <a href="#">
                                                        <Image src={require('../../../assets/Facebook.png')} />
                                                    </a>
                                                </SocialButton>
                                            </div>
                                        </div>
                                    </div>

                                </Section>
                            </Modal.Content>
                        </Modal>
                    </div>
                </div>
            )

        }


        if (!this.state.signupSuccess) {
            return (
                <div>
                    {this.state.signupFailMsg}
                </div>
            )
        }

        if (this.state.haveAcct) {
            return (
                <LoginModal showSignInModal={true} />
            )
        }




    }

}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/signup.js